import {
    AnmaldArbete,
    AssistansErsattningOptions,
    DinMisstanke,
    MedvetetFel,
    VilkenRoll,
    VilkenSituation,
    Anonym,
    Underrattelseskyldighet,
} from "@/store/types";

export const VilkenRollText = {
    [VilkenRoll.MYNDIGHET]:
        "impulskontrollutredning.anmalan.forsteg.lamnatips.vilkenroll.radioknapp.myndighet",
    [VilkenRoll.PRIVATPERSON]:
        "impulskontrollutredning.anmalan.forsteg.lamnatips.vilkenroll.radioknapp.privatperson",
};
export const DinMisstankeText = {
    [DinMisstanke.FORETAG]:
        "impulskontrollutredning.anmalan.forsteg.lamnatips.misstanke.radioknapp.foretag",
    [DinMisstanke.PRIVATPERSON]:
        "impulskontrollutredning.anmalan.forsteg.lamnatips.misstanke.radioknapp.privatperson",
};
export const VilkenSituationText = {
    [VilkenSituation.ARBETAR_SAMTIDIGT]:
        "impulskontrollutredning.anmalan.alla.misstanke.generell.privat.situation.radioknapp.etikett.arbetarsamtidigt",
    [VilkenSituation.SAMMANBOENDE]:
        "impulskontrollutredning.anmalan.alla.misstanke.generell.privat.situation.radioknapp.etikett.sammanboende",
    [VilkenSituation.FLYTT_UTOMLANDS]:
        "impulskontrollutredning.anmalan.alla.misstanke.generell.privat.situation.radioknapp.etikett.flyttutomlands",
    [VilkenSituation.ASSISTENSERSATTNING]:
        "impulskontrollutredning.anmalan.alla.misstanke.generell.privat.situation.radioknapp.etikett.assistansersattning",
    [VilkenSituation.STATLIGT_TANDVARDSSTOD]:
        "impulskontrollutredning.anmalan.alla.misstanke.generell.foretag.situation.radioknapp.etikett.statligttandvardsstod",
    [VilkenSituation.FORETAG_ASSISTANSERSATTNING]:
        "impulskontrollutredning.anmalan.alla.misstanke.generell.foretag.situation.radioknapp.etikett.assistansersattning",
    [VilkenSituation.PRIVAT_ANNAN]:
        "impulskontrollutredning.anmalan.alla.misstanke.generell.privat.situation.radioknapp.etikett.annan",
    [VilkenSituation.FORETAG_ANNAN]:
        "impulskontrollutredning.anmalan.alla.misstanke.generell.foretag.situation.radioknapp.etikett.annan",
};
export const UnderrattelseskyldighetText = {
    [Underrattelseskyldighet.JA]: "SBRV.RW.radioknapp.etikett.ja",
    [Underrattelseskyldighet.NEJ]: "SBRV.RW.radioknapp.etikett.nej",
};
export const MedvetetFelText = {
    [MedvetetFel.JA]: "SBRV.RW.radioknapp.etikett.ja",
    [MedvetetFel.NEJ]: "SBRV.RW.radioknapp.etikett.nej",
    [MedvetetFel.VETINTE]:
        "impulskontrollutredning.anmalan.generell.radioknapp.vetinte",
};
export const AnmaldArbeteText = {
    [AnmaldArbete.ANSTALLD]:
        "impulskontrollutredning.anmalan.alla.misstanke.arbetarsamtidigt.privat.radioknapp.vadstammerin.anstalld",
    [AnmaldArbete.VERKSAMHET]:
        "impulskontrollutredning.anmalan.alla.misstanke.arbetarsamtidigt.privat.radioknapp.vadstammerin.egenversamhet",
};
export const AssistansErsattningText = {
    [AssistansErsattningOptions.ANNAT]:
        "impulskontrollutredning.anmalan.alla.misstanke.assistansersattning.generell.alla.radioknapp.annat",
    [AssistansErsattningOptions.ASSISTANS_UTFORS_INTE]:
        "impulskontrollutredning.anmalan.alla.misstanke.assistansersattning.generell.alla.radioknapp.assistansutforsinte",
    [AssistansErsattningOptions.FELAKTIG_REDOVISNING]:
        "impulskontrollutredning.anmalan.alla.misstanke.assistansersattning.generell.alla.radioknapp.assistenttimmarfel",
    [AssistansErsattningOptions.LATSAS_BEHOV]:
        "impulskontrollutredning.anmalan.alla.misstanke.assistansersattning.generell.alla.radioknapp.latsashabehov",
};

export const AnonymText = {
    [Anonym.JA]: "SBRV.RW.radioknapp.etikett.ja",
    [Anonym.NEJ]: "SBRV.RW.radioknapp.etikett.nej",
};
